import Datepicker from "js-datepicker/dist/datepicker.min";
import Inputmask from "inputmask/bundle";

export default function Input(){

    const body = document.querySelector('body');
    let inputContainers = document.querySelector('[data-input="password"]');

    if(inputContainers){
        body.addEventListener('click', function (e) {
            let iconContainer = e.target.closest('[data-input-icon]');
            if (!iconContainer) return;

            let inputContainer = iconContainer.closest('[data-input="password"]');
            let input = inputContainer.querySelector('input');
            let checkBox = iconContainer.querySelector('input[type="checkbox"]');
            let icon = iconContainer.querySelector('i');

            if(checkBox.checked){
                input.setAttribute('type','text');
                icon.classList.remove('icon-close-eye');
                icon.classList.add('icon-eye');
            }
            else{
                input.setAttribute('type','password');
                icon.classList.remove('icon-eye');
                icon.classList.add('icon-close-eye');
            }
        });
    }

    let inputMaskInit = function (){
        let items = document.querySelectorAll('[data-mask]');
        if (items.length) {
            items.forEach(item => {
                let maskValue = item.dataset.mask;
                let input = item.querySelector('input');

                if (!input.inputmask) {
                    new Inputmask(maskValue, {
                        //"placeholder": '',
                        clearIncomplete: true,
                        clearMaskOnLostFocus: true,
                        showMaskOnHover: false
                    }).mask(input);
                }
            })
        }
    }

    let buttonCheckFieldInit = function (){
        //Проверка полей на заполненность. data-btn-check необходимо указать у кнопки которая будет недоступна пока все поля с data-check-group не будут заполнены.
        let buttonsCheckField = document.querySelectorAll('[data-btn-check]');

        if (buttonsCheckField.length) {

            buttonsCheckField.forEach(buttonCheckField => {

                if(!buttonCheckField.classList.contains('input-check-initialized')){

                    let checkFields = document.querySelectorAll('[data-check-group="'+ buttonCheckField.dataset.btnCheck +'"]');
                    let flag = false;

                    checkFields.forEach(checkField => {

                        let handler = function (){

                            flag = false;
                            checkFields.forEach(field => {
                                if (field.value ==='')
                                    flag = true;
                                else
                                    switch (field.getAttribute('type')) {
                                        case 'email':
                                            const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
                                            if(!EMAIL_REGEXP.test(field.value))
                                                flag = true;
                                            break;
                                        case 'tel':
                                            const PHONE_REGEXP = /\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}/;
                                            if(!PHONE_REGEXP.test(field.value))
                                                flag = true;
                                            break;
                                        case 'date-custom':
                                            const DATE_REGEXP = /\d{2}.\d{2}.\d{4}/;
                                            if(!DATE_REGEXP.test(field.value))
                                                flag = true;
                                            break;
                                    }
                            })

                            if (flag){
                                buttonCheckField.classList.add('button--disabled');
                                buttonCheckField.setAttribute('disabled','disabled');
                            }else{
                                buttonCheckField.classList.remove('button--disabled');
                                buttonCheckField.removeAttribute('disabled','disabled');
                            }
                        }

                        checkField.addEventListener('keyup', handler);
                        //checkField.addEventListener('change', handler);
                    });

                    buttonCheckField.classList.add('input-check-initialized');
                }
            });
        }
    }

    let calendarInputInit = function (){
        let calendarContainers = document.querySelectorAll('[data-input-calendar="container"]');

        if (calendarContainers.length) {
            let calendarInput,
                calendarButton,
                picker,
                isHidden,
                oldCalendar;

            calendarContainers.forEach(calendarContainer => {
                calendarInput = calendarContainer.querySelector('[data-input-calendar="input"]');
                calendarButton = calendarContainer.querySelector('[data-input-calendar="button"]');
                oldCalendar = calendarContainer.querySelector('.qs-datepicker-container');

                if(!oldCalendar){
                    picker = datepicker(calendarInput,{
                        position:"br",
                        customDays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
                        customMonths: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                        overlayButton: "Подтвердить",
                        overlayPlaceholder: 'Введите год',

                        formatter: (input, date, instance) => {
                            input.value = date.toLocaleDateString();

                            let event = new Event("keyup", {bubbles : true, cancelable : true});
                            input.dispatchEvent(event);
                        }
                    });

                    picker.calendarContainer.style.setProperty('font-family', '"Fira Sans", sans-serif');

                    calendarButton.addEventListener('click', e => {
                        e.stopPropagation();
                        picker.disabled = false;
                        isHidden = picker.calendarContainer.classList.contains('qs-hidden');
                        picker[isHidden ? 'show' : 'hide']()
                    });

                    calendarInput.addEventListener('focus', e => {
                        isHidden = picker.calendarContainer.classList.contains('qs-hidden');
                        picker.disabled = isHidden;
                    });
                }

            });
        }
    }

    inputMaskInit();
    buttonCheckFieldInit();
    calendarInputInit();

    let observer = new MutationObserver(mutationRecords => {
        inputMaskInit();
        buttonCheckFieldInit();
        calendarInputInit();
    });

    observer.observe(body, {
        childList: true, // наблюдать за непосредственными детьми
        subtree: true, // и более глубокими потомками
        characterDataOldValue: true // передавать старое значение в колбэк
    });

}